import { mixins, styled } from '@bob/library'

interface TextProps {
  background?: string
}

export const Text = styled.div<TextProps>`
  display: inline-block;
  padding: 15px 20px;
  border-radius: 100px;
  ${({ background }) => (background ? `background: ${background}` : undefined)};
  ${mixins.typography.subtitleLarge}

  ${mixins.media.max.desktop} {
    ${mixins.typography.subtitleMedium}
  }
`

export const ConnectorWrapper = styled.div`
  ${mixins.margin(15, 0)}
`

export const TextWrapper = styled.div`
  text-align: center;
`
